import styled from "styled-components";

export const ContactWrapper = styled.div`
  margin: 5rem 0;
  position: relative;

  &::before {
    content: '';
    position: absolute;
    top: -50px;
    left: 50%;
    transform: translateX(-50%);
    width: 100px;
    height: 4px;
    background: linear-gradient(45deg, #ffffff 0%, #cccccc 100%);
    border-radius: 2px;
  }
`;

export const Email = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  margin-bottom: 2rem;
  background: linear-gradient(135deg, #000000 0%, #333333 100%);
  border-radius: 20px;
  padding: 2.5rem 2rem;
  box-shadow: 0 15px 35px rgba(0, 0, 0, 0.1), 0 5px 15px rgba(0, 0, 0, 0.05);
  transition: all 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  border: 2px solid transparent;
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
    transition: left 0.5s;
  }

  &:hover {
    transform: translateY(-10px);
    box-shadow: 0 25px 50px rgba(0, 0, 0, 0.2), 0 10px 25px rgba(0, 0, 0, 0.1);
    border-color: rgba(255, 255, 255, 0.3);

    &::before {
      left: 100%;
    }
  }

  span {
    font-size: 1.2rem;
    font-weight: 500;
    margin-bottom: 1.5rem;
    color: #ffffff;
    line-height: 1.4;
    text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    z-index: 2;
    position: relative;
  }

  @media (min-width: 576px) {
    span {
      font-size: 1.4rem;
    }
  }

  @media (min-width: 992px) {
    flex-direction: column;
    span {
      margin-bottom: 1.5rem;
      font-size: 1.6rem;
    }
  }

  /* Button container styling */
  div {
    z-index: 2;
    position: relative;

    .btn {
      transition: all 0.3s ease;
      border: 2px solid rgba(255, 255, 255, 0.8);

      &:hover {
        background: rgba(255, 255, 255, 0.9) !important;
        color: #000000 !important;
        transform: translateY(-2px);
        box-shadow: 0 8px 15px rgba(0, 0, 0, 0.2);
      }
    }
  }
`;
